import React, { useState, useEffect, useRef } from 'react';
import Drawer from '../../../../../components/src/UI/Drawer';
import MyBets from '../../../MyBets';
import DateRangeFilter from '../../../../../components/src/UI/DateRangeFilter';
import CloseButton from '../../../../../components/src/UI/CloseButton';
import { useAssistantActions } from '../../hooks/useLottoAssistantContext';
import classes from './MyBetsDrawer.module.scss';

const MyBetsDrawer = ({ isOpen, onClose, args }) => {
  const { trackLottoEvent } = useAssistantActions();
  const prevOpenRef = useRef(false);

  const [dateFilter, setDateFilter] = useState({
    from: args?.dateFilter?.from ?? null,
    to: args?.dateFilter?.to ?? null,
  });

  useEffect(() => {
    if (isOpen && !prevOpenRef.current) {
      trackLottoEvent?.('my_bets_opened', {});
    }
    prevOpenRef.current = isOpen;
  }, [isOpen, trackLottoEvent]);

  return (
    <Drawer isOpen={isOpen} onClose={onClose} customClass={classes.Drawer}>
      <div className={classes.Container}>
        <div className={classes.Puller} />

        <div className={classes.Header}>
          <div className={classes.HeaderLeft}>
            <p className={classes.HeaderTitle}>My Bets</p>
            <DateRangeFilter
              title="Draw Date"
              initialFrom={dateFilter.from}
              initialTo={dateFilter.to}
              popupAlign="left"
              onApply={(from, to) =>
                setDateFilter({ from: from ?? null, to: to ?? null })
              }
              onClear={() => setDateFilter({ from: null, to: null })}
            />
          </div>

          <CloseButton onClick={onClose} />
        </div>

        <div className={classes.Content}>
          {isOpen && (
            <MyBets dateFilter={dateFilter} trackLottoEvent={trackLottoEvent} />
          )}
        </div>
      </div>
    </Drawer>
  );
};

export default MyBetsDrawer;
